<template>
  <div class="box">
    <div class="boxa">
      班次名称:
      <Input v-model="value1" placeholder="请输入班次名称" style="width: 200px" />
    </div>
    <div class="boxb">
      默认班次:
      <el-switch v-model="value2" :active-value="1" :inactive-value="2"> </el-switch>
    </div>
    <div class="boxb">
      是否上班:
      <el-switch v-model="value3" :active-value="true" :inactive-value="false">
      </el-switch>
    </div>
    <div class="boxc" v-if="value3">
      <span>上班时间:</span>
      <div class="boxc3">
        <TimePicker
          format="HH:mm"
          placeholder="选择时间"
          style="width: 112px"
          @on-change="gettime1"
        />
      </div>
    </div>
    <div class="boxc" v-if="value3">
      <span>下班时间:</span>
      <div class="boxc3">
        <TimePicker
          format="HH:mm"
          placeholder="选择时间"
          style="width: 112px"
          @on-change="gettime2"
        />
      </div>
    </div>
    <div class="boxd" style="display: flex; align-items: center">
      请选择颜色：<el-color-picker v-model="colorStr"></el-color-picker>
    </div>
    <div style="display: flex; justify-content: center; margin: 40px 0">
      <Button type="primary" style="margin: 0 20px 0 0" @click="onAdd()"> 确认 </Button>
      <Button type=" primary" @click="$emit('onCancel')"> 取消 </Button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value1: "",
      value2: 2,
      value3: true,
      colorStr: "",
      week1: [],
      week3: "",
      startTime: "",
      endTime: "",
      model: [],
      engineerList: [],
      selectedTimes: [],
      engineerNameList: [],
    };
  },
  props: ["onCancel"],
  created() {
    this.getengineer();
  },
  methods: {
    xuanengineer(val) {
      if (val != []) {
        this.engineerNameList = val.map((item) => {
          return item.value;
        });
      }
    },
    getengineer() {
      let q = {};
      $utils.api.load(`/admin/system/maiUser/maiUserByClasses`, q).then((res) => {
        if (res && res.data) {
          let arr = res.data;
          this.engineerList = arr.map((item) => {
            return { value: item.userId, label: item.nickName };
          });
        }
      });
    },
    onAdd() {
      let q = {};
      q.name = this.value1;
      q.isDefault = this.value2;
      q.workStartTime = this.startTime;
      console.log(this.colorStr);
      if (!this.colorStr) {
        $utils.toast.success("请选择颜色！");
        return;
      }
      q.color = this.colorStr;
      q.workEndTime = this.endTime;
      if (!this.value3) {
        q.workStartTime = "00:00";
        q.workEndTime = "00:00";
      }
      $utils.api.load(`/admin/system/classes/add`, q, "post").then((res) => {
        if (res.code == 200) {
          $utils.toast.success("新增成功");
          this.$emit("onCancel"); //保存后关闭弹窗
        }
      });
    },
    getweek(val) {
      var dayMap = {
        周日: "1",
        周一: "2",
        周二: "3",
        周三: "4",
        周四: "5",
        周五: "6",
        周六: "7",
      };
      this.week3 = val
        .map(function (day) {
          return dayMap[day];
        })
        .join(",");
    },
    gettime1(val) {
      this.startTime = val;
    },
    gettime2(val) {
      this.endTime = val;
    },
  },
};
</script>

<style>
.box {
}

.boxc2 {
  display: inline-block;
  margin-left: 15px;
}

.boxc3 {
  display: inline-block;
  margin-left: 5px;
}

.boxa,
.boxb,
.boxc,
.boxd {
  margin: 10px 0;
}
</style>
